import { Entity } from '../../entity';
import { EntityFlag } from '../../shared/flag';

/**
 * Compliance overdue attention (WBS-11940): a statutory task whose due date passed without the work
 * done raises a Flag on its Service Plan. These constants are the wire contract between the API that
 * raises and closes the flag and the web that lists it and offers "Book now".
 */

/**
 * The seeded system flag category. Fixed so every tenant, the raise path and the web agree on it
 * without a lookup; the tenant may rename or recolour it, which is why readers match on the id.
 */
export const COMPLIANCE_OVERDUE_FLAG_CATEGORY_ID = '0199e0c4-2f40-7c35-9d7e-0c0e11940a01';

export const COMPLIANCE_OVERDUE_FLAG_CATEGORY_NAME = 'Compliance overdue';

/** `EntityFlag.source` of every compliance flag; auto-close and the digest select on it. */
export const COMPLIANCE_OVERDUE_FLAG_SOURCE = 'planned-work.compliance-overdue';

/** Flag entity-data commands; the id is the CQRS command name the flag strategy routes. */
export enum ComplianceOverdueFlagCommandId {
    BookNow = 'VisitComplianceBookNowCommand',
}

export interface ComplianceOverdueBookNowRequest {
    flagId: string;
}

/** Days-overdue bands the Compliance board filters and seeds views on; the API derives the band per row. */
export enum ComplianceOverdueBand {
    UpToWeek = '1–7',
    UpToMonth = '8–30',
    OverMonth = '30+',
}

/** Bulk Close runs one Close per row; the cap keeps a mis-selection from closing a tenant's backlog in one click. */
export const COMPLIANCE_BULK_CLOSE_CAP = 50;

/** One Compliance board row: the flag's own fields plus what the board joins and derives. */
export interface ComplianceFlagBoardRow extends EntityFlag {
    task?: Entity;
    customer?: Entity;
    site?: Entity;
    servicePlan?: Entity;
    serviceLine?: Entity;
    owner?: Entity;
    /** YYYY-MM-DD, read from the Visit link the raise path names with the deadline. */
    dueDate?: string;
    /** Whole days from the deadline to the close, or to today while open. */
    daysOverdue?: number;
    overdueBand?: ComplianceOverdueBand;
}
